export const ImagePlaceholderIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="5" width="30" height="22" rx="2" stroke="currentColor" strokeWidth="2"/>
        <path d="M1 26L10.3638 14.9451C10.7756 14.4589 11.531 14.4767 11.9195 14.9818L16.7735 21.2923C17.108 21.7272 17.7305 21.8113 18.1685 21.4808L21.103 19.2664C21.4632 18.9945 21.9609 18.9977 22.3177 19.2741L31 26" stroke="currentColor" strokeWidth="2"/>
        <path d="M27 12C27 13.6569 25.6569 15 24 15C22.3431 15 21 13.6569 21 12C21 10.3431 22.3431 9 24 9C25.6569 9 27 10.3431 27 12Z" stroke="currentColor" strokeWidth="2"/>
    </svg>
  )
}
export const ImagePlaceholderIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="5" width="30" height="22" rx="2" stroke="currentColor" strokeWidth="2"/>
        <path d="M1 26L10.3638 14.9451C10.7756 14.4589 11.531 14.4767 11.9195 14.9818L16.7735 21.2923C17.108 21.7272 17.7305 21.8113 18.1685 21.4808L21.103 19.2664C21.4632 18.9945 21.9609 18.9977 22.3177 19.2741L31 26" stroke="currentColor" strokeWidth="2"/>
        <path d="M27 12C27 13.6569 25.6569 15 24 15C22.3431 15 21 13.6569 21 12C21 10.3431 22.3431 9 24 9C25.6569 9 27 10.3431 27 12Z" stroke="currentColor" strokeWidth="2"/>
    </svg>
  )
}
